module.exports = __webpack_public_path__ + "img/Lulu-mall-kochi.81bdc573.jpg";